import { useState, useEffect } from 'react';
import Button from '../sf-components/Button/Button';
import Snackbar from './Snackbar';
import xExitIcon from '../common/NewImages/x-exit.svg';

const SnackbarSelectActions = ({ name, nameSingleSelected, selectedSum, open, buttons, onClickExit }) => {
    const [selectedSumToShow, setSelectedSumToShow] = useState(selectedSum);

    useEffect(() => {
        if (open) {
            setSelectedSumToShow(selectedSum);
        }
    }, [open, selectedSum]);

    return (
        <Snackbar open={open}>
            <div className="bg-sf-gray-800 rounded-lg px-6 h-16 flex items-center gap-6 text-white">
                <div>
                    <div className="text-10 text-sf-gray-200">selected</div>
                    <div className="text-sf">
                        {`${selectedSumToShow} ${selectedSumToShow === 1 ? name : nameSingleSelected || name}`}
                    </div>
                </div>
                <div className="flex gap-2">
                    {buttons.map((button) => (
                        <Button key={button.text} buttonStyle="Ghost" text={button.text} onClick={button.onClick} />
                    ))}
                </div>
                <button onClick={onClickExit}>
                    <img src={xExitIcon} alt="" />
                </button>
            </div>
        </Snackbar>
    );
};

export default SnackbarSelectActions;
